import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  Typography,
  Container,
  CircularProgress,
  Paper,
  Box,
} from "@mui/material";
import useUser from "context/user/useUser";
import { getToken } from "auth/authenticate";
import AptExtFillTheData from "../ExtAppointmentSetupComplete/AptExtFillTheData";

const ExternalAppointmentSetup = () => {
  const { appointmentId } = useParams();
  const { settings } = useUser();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("ok");
  const [loading, setLoading] = useState(true);
  const [validationStatusMsg, setValidationStatusMsg] = useState(null);
  const [validatedData, setValidatedData] = useState(null);

  // Extracted data states
  const [appointmentData, setAppointmentData] = useState(null);
  const [patientData, setPatientData] = useState(null);
  const [doctorData, setDoctorData] = useState(null);
  const [validatedPayment, setValidatedPayment] = useState(null);

  useEffect(() => {
    const validateAndHandle = async () => {
      if (!appointmentId || !token) {
        setValidationStatusMsg("Invalid or missing URL parameters.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const config = {
          headers: { Authorization: `Bearer ${getToken()}` },
        };

        const data = { paymentToken: token, appointmentId };

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}appointment/validate/ext-link/${appointmentId}`,
          data,
          config
        );

        const validationData = response?.data?.data;
        const validateStatus = validationData.validateStatusData?.aptValidatedData.verify;
        const validatedPayment = validationData.validateStatusData?.aptValidatedData.payType;

        if (validateStatus) {
          setValidationStatusMsg("Appointment link is valid.");
          setValidatedData(validationData);
          setAppointmentData(validationData.appointment);
          setPatientData(validationData.appointment?.Patient);
          setDoctorData(validationData.appointment?.Doctor);
          setValidatedPayment(validatedPayment);
        } else {
          setValidationStatusMsg("Invalid or expired appointment link.");
        }
      } catch (error) {
        console.error("Validation error:", error);
        setValidationStatusMsg("Validation failed due to an error.");
      } finally {
        setLoading(false);
      }
    };

    validateAndHandle();
  }, [appointmentId, token]);

  if (loading) {
    return (
      <Container>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }
  
  return (
    <Container>
      <h2 style={{fontSize: '24px',fontWeight: 'bold',color: '#1a73e8',marginBottom: '10px'}}>
        Appointment Validation
      </h2>
      {validationStatusMsg && (
        <Typography variant="body1" color="textSecondary" gutterBottom>
          {validationStatusMsg}
        </Typography>
      )}

{appointmentData && patientData && doctorData && validatedPayment ? (
  
  <Box mt={4}>
    <AptExtFillTheData
      patientData={patientData}
      doctorData={doctorData}
      appointmentId={appointmentId}
      appointmentData={appointmentData}
      validatedPayment={validatedPayment}
    />
  </Box>
) : (
  <Box mt={4} mb={8} p={2} textAlign="center">
    <Typography variant="body1" color="error">
      Unable to proceed with payment.
    </Typography>
  </Box>
)}
    </Container>
  );
};

export default ExternalAppointmentSetup;
